import type { NewUserQuizCopy } from '../types';

export const RU_NEW_USER_QUIZ_COPY = {
  booking: {
    bookedSnackbar: 'Демо забронировано — до встречи!',
    bullets: {
      pricing: 'Прозрачная цена с учётом объёма и уровня поддержки',
      teams: 'Для команд: ревьюеры, глоссарии и единая библиотека',
      setup: 'Подберите оптимальную конфигурацию для вашего контента и процессов',
    },
    description: 'Узнайте, как Rask передаёт индивидуальность, замысел и контекст на разных языках.',
    heading: 'Узнайте, как Rask впишется в ваши процессы',
    headingSecondLine: 'Забронируйте демо и посмотрите Rask в действии',
    maybeLater: 'Возможно, позже',
    rating: '4,7 из 5 на G2',
    scheduler: {
      openBookingPage: 'Открыть страницу бронирования',
      loadErrorDescription:
        'Возможно, ваша сеть или регион блокирует встроенный виджет. Откройте страницу бронирования в новой вкладке.',
      loadErrorTitle: 'Не удалось загрузить календарь',
      loadingLabel: 'Загрузка календаря',
    },
    trustedBy: 'Нам доверяют команды по всему миру',
  },
  controls: {
    back: 'Назад',
    continue: 'Продолжить',
    continueAnyway: 'Всё равно продолжить',
    progress: (currentStep, totalSteps) => `Вопрос ${currentStep} из ${totalSteps}`,
    submitError: 'Не удалось сохранить ваши ответы. Попробуйте ещё раз.',
  },
  priorityQuestion: {
    title: 'Что для вас важнее всего при локализации видео?',
    audioTitle: 'Что для вас важнее всего при локализации контента?',
    options: {
      collaborate_with_team_or_reviewers: { label: 'Совместная работа с командой или ревьюерами' },
      consistent_voice_and_terminology: { label: 'Единый голос и терминология' },
      fast_results_no_setup: { label: 'Быстрый результат без настройки' },
      integration_into_product_or_workflow: { label: 'Интеграция в наш продукт или рабочий процесс' },
      not_sure_yet: { label: 'Пока не определились' },
    },
    subtitle: 'Выберите все подходящие варианты',
  },
  questions: {
    content_team_size: {
      title: 'Какого размера ваша команда по работе с контентом?',
      options: {
        just_me: { label: 'Только я' },
        large_team_5_plus: { label: 'Большая команда', description: '5 и более человек' },
        small_team_2_5: { label: 'Небольшая команда', description: 'От 2 до 5 человек' },
      },
    },
    localization_frequency: {
      title: 'Как часто вы переводите, озвучиваете или локализуете видео?',
      audioTitle: 'Как часто вы переводите, озвучиваете или локализуете контент?',
      options: {
        continuously: { label: 'Постоянно', description: 'Непрерывный поток задач' },
        occasionally_quarterly: { label: 'Иногда', description: 'Примерно раз в квартал' },
        regularly_monthly: { label: 'Регулярно', description: 'Каждый месяц' },
        one_time_project: { label: 'Разовый проект', description: 'Один проект, без продолжения' },
      },
    },
    localized_videos_before: {
      title: 'Вы уже локализовали видео?',
      options: {
        false: { label: 'Нет' },
        true: { label: 'Да' },
      },
      subtitle: 'Несколько коротких вопросов, чтобы персонализировать ваш опыт',
    },
    target_language_count: {
      title: 'На сколько языков вы планируете локализовать контент?',
      options: {
        changes_by_project: { label: 'Зависит от проекта', description: 'Без фиксированного количества' },
        four_to_ten: { label: '4 – 10', description: 'Несколько рынков одновременно' },
        ten_plus: { label: '10+', description: 'Широкий, масштабный запуск' },
        two_to_three: { label: '2 – 3', description: 'Несколько рынков' },
        one: { label: '1', description: 'Только один язык' },
      },
    },
  },
} satisfies NewUserQuizCopy;
